
import RfpFilter from "@/Components/Rfp/RfpFilter.vue";
import RfpType from "@/types/Rfp/Rfp";
import { PropType, defineComponent, ref } from "vue";
// @ts-ignore
import { ColumnState } from "ag-grid-community";
import dayjs from "dayjs";
import { AxiosTransformer } from "axios";
import RfpTitleGridRendererVue from "@/Components/Rfp/RfpTitleGridRenderer.vue";
import RfpCategory from "@/types/Rfp/RfpCategory";
import customParseFormat from "dayjs/plugin/customParseFormat"
// @ts-ignore
import Datatable from "@/Components/General/Datatable.vue";
import { Inertia } from "@inertiajs/inertia";
import route from "ziggy-js";
import AppLayout from "@/Layouts/AppLayout.vue";
import HcButton from "@/Components/Buttons/Button.vue";
dayjs.extend(customParseFormat)
export default defineComponent({
  components: {
    HcButton,
    RfpFilter,
    Datatable,
    RfpTitleGridRendererVue,
  },

  props: {
    allCategories: {
      type: Object as PropType<RfpCategory[]>,
      required: true,
    }
  },
  setup(props) {
    const total = ref(0);
    const isDueDate = (date: Date | string) => {
      if (!date) {
        return false;
      }
      const parsedDate = dayjs(date, "DD.MM.YYYY");
      const currentDate = dayjs()

      return parsedDate.isBefore(currentDate) || parsedDate.isSame(currentDate);
    };
    const columns = [
      {
        headerName: "Tittel",
        field: "title",
        autoHeight: true,
        sortable: true,
        cellRenderer: RfpTitleGridRendererVue,
        cellClassRules: {
          'bg-red-300 dark:bg-red-900 text-red-900 dark:text-red-200': (params: any) => isDueDate(params?.data?.deadline),
        },
      },
      {
        headerName: "Kategorier",
        field: "categories",
        sortable: false,
        maxWidth: 280,
        cellClassRules: {
          'bg-red-300 dark:bg-red-900 text-red-900 dark:text-red-200': (params: any) => isDueDate(params?.data?.deadline),
        },
      },
      {
        headerName: "Tildelte",
        field: "assignedString",
        sortable: false,
        cellClassRules: {
          'bg-red-300 dark:bg-red-900 text-red-900 dark:text-red-200': (params: any) => isDueDate(params?.data?.deadline),
        },
      },
      {
        headerName: "Må behandles og lukkes innen",
        field: "deadline",
        cellClassRules: {
          'bg-red-300 dark:bg-red-900 text-red-900 dark:text-red-200': (params: any) => isDueDate(params?.data?.deadline),
        },
      },
      {
        headerName: "Opprettet",
        field: "created_at",
        maxWidth: 180,
        sortable: true,
        cellClassRules: {
          'bg-red-300 dark:bg-red-900 text-red-900 dark:text-red-200': (params: any) => isDueDate(params?.data?.deadline),
        },
      },
    ];

    const defaultSortModel: ColumnState[] | undefined = [
      {
        colId: "created_at",
        sort: "desc",
      },
    ];

    const mobileColumnDefs = [
      {
        headerName: "Tittel",
        field: "title",
        autoHeight: true,
        sortable: true,
        cellClassRules: {
          'bg-red-300 dark:bg-red-900 text-red-900 dark:text-red-200': (params: any) => isDueDate(params?.data?.deadline),
        },
      },
      {
        headerName: "Opprettet",
        field: "created_at",
        maxWidth: 180,
        sortable: true,
        cellClassRules: {
          'bg-red-300 dark:bg-red-900 text-red-900 dark:text-red-200': (params: any) => isDueDate(params?.data?.deadline),
        },
      },
    ];

    const filter = ref({});

    const navigateToRfp = (row: any) => {
      Inertia.get(route("rfp.show", { rfp: row.data.id }));
    };

    const routeName = "rfp.tabledata";

    const responseTransformer: AxiosTransformer = (json: string, headers) => {
      const transformed: {
        id: number;
        title: string;
        created_at: string;
        deadline: string;
        assignedString: string;
        closed_at: string | null;
        categories: string;
      }[] = [];

      const data: { total: number; rfps: RfpType[] } = JSON.parse(json) ?? [];
      total.value = data.total;
      data.rfps.forEach((rfp) => {
        transformed.push({
          id: rfp.id,
          title: rfp.title,
          created_at: dayjs(rfp.created_at).format("L LT"),
          deadline: rfp.deadline ? dayjs(rfp.deadline).format("L") : '',
          assignedString:
            rfp.assigned
              ?.map((assigned) => {
                return assigned.firstname + " " + assigned.lastname;
              })
              .join(", ") ?? "",
          closed_at: rfp.closed_at,
          categories: rfp.categories.map((cat) => cat.title).join(", "),
        });
      });

      return {
        total: data.total,
        data: transformed,
      };
    };

    return {
      filter,
      columns,
      routeName,
      defaultSortModel,
      mobileColumnDefs,
      responseTransformer,
      navigateToRfp,
      total
    };
  },
  layout: AppLayout,
});
